module.exports = __webpack_public_path__ + "media/packs/images/flags/BL-b20b7739b6606257a5c09ccf8c968349.svg";